import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import {ForecastQueryRenderer} from '../../../ForecastQueryRenderer';
import {useClientContactProjectOptions, ProjectsViewerEdges, ProjectOption} from './hooks/useClientContactProjectOptions';

export const clientContactModalProjectsLoaderQuery = graphql`
	query ClientContactModalProjectsLoaderQuery {
		viewer {
			component(name: "client_contact_modal_projects")
			actualPersonId
			projects(first: 100000) @connection(key: "Viewer_projects", filters: []) {
				edges {
					node {
						id
						name
						customProjectId
						projectColor
						client {
							id
						}
					}
				}
			}
		}
	}
`;

export type ClientContactModalProjectsLoaderProps = {
	clientId: string;
	children: (modalProps: {projectOptions: ProjectOption[]; isProjectsLoading: boolean}) => React.ReactNode;
};

type ProjectOptionsInnerProps = {
	edges: ProjectsViewerEdges | undefined;
	clientId: string;
	children: ClientContactModalProjectsLoaderProps['children'];
};

const ProjectOptionsInner = ({edges, clientId, children}: ProjectOptionsInnerProps) => {
	const projectOptions = useClientContactProjectOptions(edges, clientId);
	return <>{children({projectOptions, isProjectsLoading: false})}</>;
};

const ClientContactModalProjectsLoader = ({clientId, children}: ClientContactModalProjectsLoaderProps) => (
	<ForecastQueryRenderer
		key="client-contact-projects"
		query={clientContactModalProjectsLoaderQuery}
		modal={true}
		alwaysRender={true}
		variables={{}}
		render={(relayProps: {viewer?: {projects?: {edges?: ProjectsViewerEdges}}} | null) => {
			if (!relayProps || !relayProps.viewer) {
				return <>{children({projectOptions: [], isProjectsLoading: true})}</>;
			}
			return <ProjectOptionsInner edges={relayProps.viewer.projects?.edges} clientId={clientId} children={children} />;
		}}
	/>
);

export default ClientContactModalProjectsLoader;
